(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gummy-brand-mark"] && !Shopify.designMode) return;
  try {
    (function() {
    function getPart(parts, type) {
      var part = parts.find(function(item) {
        return item.type === type;
      });
      return part ? part.value : '';
    }

    function updateGummyClocks() {
      var clocks = document.querySelectorAll('[data-gummy-clock]');
      if (!clocks.length) return;

      var now = new Date();
      var parts = new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
        hour12: true
      }).formatToParts(now);
      var timeZoneLabel = getPart(parts, 'timeZoneName') || 'local';

      var value = [
        getPart(parts, 'month'),
        '/',
        getPart(parts, 'day'),
        '/',
        getPart(parts, 'year'),
        ' ',
        getPart(parts, 'hour'),
        ':',
        getPart(parts, 'minute'),
        ' ',
        getPart(parts, 'dayPeriod').toUpperCase(),
        ' ',
        timeZoneLabel
      ].join('');

      clocks.forEach(function(clock) {
        clock.textContent = value;
        clock.setAttribute('datetime', now.toISOString());
      });
    }

    if (window.gummyClockInterval) {
      window.clearInterval(window.gummyClockInterval);
    }

    updateGummyClocks();
    window.gummyClockInterval = window.setInterval(updateGummyClocks, 30000);
    document.addEventListener('shopify:section:load', updateGummyClocks);
  })();
  } catch(e) { console.error(e); }
})();

})();
